export default [
    {
        clientIds: {
            local: {
                en: 'debc4188-b320-41ff-afd6-647a4fca6349',
                es: 'debc4188-b320-41ff-afd6-647a4fca6349',
            },
            DEV: {
                en: 'debc4188-b320-41ff-afd6-647a4fca6349',
                es: 'debc4188-b320-41ff-afd6-647a4fca6349',
            },
            STAGING: {
                en: '4b3d3b54-7d40-4ce2-ae84-071aa021b606',
                es: 'e92e472c-b9ba-43bd-aa71-cfc1c793190e',
            },
            PRODUCTION: {
                en: '37ef2f93-9ea4-4e28-b1cf-e6204ffce2fa',
                es: '082638e5-133d-4063-a758-0c5e3318dba7',
            },
        },
        fullName: 'Affiliate Mall',
        internalIdentifier: 'am',
        serviceUuids: {
            local: {
                en: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
                es: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
            },
            DEV: {
                en: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
                es: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
            },
            STAGING: {
                en: '8b56cfed-9742-4dd0-b6de-430808fa760f',
                es: '0b04c8cc-7d6f-4bfa-a426-1e0db9992d65',
            },
            PRODUCTION: {
                en: 'b08c0e5c-d155-4403-bd39-8bf5457a972e',
                es: '5ba9d586-0f29-44e4-a9b7-95a226e2a7b6',
            },
        },
        twoDigitCode: 'AM',
    },
    {
        clientIds: {
            local: {
                en: 'debc4188-b320-41ff-afd6-647a4fca6349',
                es: 'debc4188-b320-41ff-afd6-647a4fca6349',
            },
            DEV: {
                en: 'debc4188-b320-41ff-afd6-647a4fca6349',
                es: 'debc4188-b320-41ff-afd6-647a4fca6349',
            },
            STAGING: {
                en: '4b3d3b54-7d40-4ce2-ae84-071aa021b606',
                es: 'e92e472c-b9ba-43bd-aa71-cfc1c793190e',
            },
            PRODUCTION: {
                en: '37ef2f93-9ea4-4e28-b1cf-e6204ffce2fa',
                es: '082638e5-133d-4063-a758-0c5e3318dba7',
            },
        },
        fullName: 'Rakuten dot com',
        internalIdentifier: 'rdc',
        serviceUuids: {
            local: {
                en: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
                es: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
            },
            DEV: {
                en: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
                es: '5d57ef66-333a-4b8e-91d3-b83638e6b653',
            },
            STAGING: {
                en: '8b56cfed-9742-4dd0-b6de-430808fa760f',
                es: '0b04c8cc-7d6f-4bfa-a426-1e0db9992d65',
            },
            PRODUCTION: {
                en: 'b08c0e5c-d155-4403-bd39-8bf5457a972e',
                es: '5ba9d586-0f29-44e4-a9b7-95a226e2a7b6',
            },
        },
        twoDigitCode: 'RC',
    },
];
